export default __webpack_public_path__ + "static/media/sturgeon.61175482.png";